import * as React from "react";

function SvgChartArea(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 19"
      focusable={false}
      role="presentation"
      aria-hidden={true}
      {...props}
    >
      <path d="M24 0v19H0a.94.94 0 01.19-.61l5.29-6.77a.63.63 0 01.94-.07l1.71 1.58A.57.57 0 009 13l3.66-5.63a.57.57 0 01.89-.11l2.6 2.49a.53.53 0 00.87-.12L23.21.41A.82.82 0 0124 0z" />
    </svg>
  );
}

const MemoSvgChartArea = React.memo(SvgChartArea);
export default MemoSvgChartArea;
